module.exports = __webpack_public_path__ + "img/新闻图片1.a15c1d09.png";